import fetchApi from 'utils/fetch';
import {
  DELETE_DISCOUNT_CODE,
  VALIDATE_DISCOUNT_CODE_REQUEST,
  VALIDATE_DISCOUNT_CODE_SUCCESS,
  VALIDATE_DISCOUNT_CODE_FAILURE,
  VALIDATE_DISCOUNT_CODE_ONLY_ONE_COUPON_ALLOWED,
  RESET_DISCOUNT_CODE_STATUS,
} from 'types/discount-code';
import {
  DELETE_CREDIT_CODE,
  VALIDATE_CREDIT_CODE_REQUEST,
  VALIDATE_CREDIT_CODE_SUCCESS,
  RESET_CREDIT_CODE_STATUS,
  DELETE_ALL_CREDIT_CODES,
} from 'types/credit-codes';
import * as helpers from './helpers';

export const deleteDiscountCode = () => ({
  type: DELETE_DISCOUNT_CODE,
});

export const deleteCreditCode = (code) => ({
  type: DELETE_CREDIT_CODE,
  payload: {
    code,
  },
});

export const deleteAllCreditCodes = () => ({
  type: DELETE_ALL_CREDIT_CODES,
});

/**
 * Create
 */
const validateDiscountCodeRequest = () => ({
  type: VALIDATE_DISCOUNT_CODE_REQUEST,
});

const validateDiscountCodeSuccess = (data) => ({
  type: VALIDATE_DISCOUNT_CODE_SUCCESS,
  payload: {
    discountCode: data,
  },
});

const resetDiscountCodeStatus = () => ({
  type: RESET_DISCOUNT_CODE_STATUS,
});

const validateCreditCodeRequest = () => ({
  type: VALIDATE_CREDIT_CODE_REQUEST,
});

const validateCreditCodeSuccess = (data) => ({
  type: VALIDATE_CREDIT_CODE_SUCCESS,
  payload: {
    creditCode: data,
  },
});

const resetCreditCodesStatus = () => ({
  type: RESET_CREDIT_CODE_STATUS,
});

export const validatePromoCode =
  (couponCode, brandId, payload) => async (dispatch, getState) => {
    const currentState = getState();
    dispatch(validateDiscountCodeRequest());
    dispatch(validateCreditCodeRequest());
    try {
      const { data } = await fetchApi
        .post(`v1/brands/${brandId}/coupon-codes/${couponCode}/validate`, {
          json: payload,
        })
        .json();
      if (
        currentState.discountCode &&
        currentState.discountCode.discountCode &&
        currentState.discountCode.discountCode.discountType === 'coupon' &&
        data.discountType === 'coupon'
      ) {
        dispatch(resetCreditCodesStatus());
        return dispatch({
          type: VALIDATE_DISCOUNT_CODE_ONLY_ONE_COUPON_ALLOWED,
          payload: {
            error: 'Only one discount code allowed at a time',
            attemptedCode: couponCode,
          },
        });
      }
      if (data.discountType === 'coupon') {
        dispatch(resetCreditCodesStatus());
        return dispatch(validateDiscountCodeSuccess(data));
      }
      dispatch(resetDiscountCodeStatus());
      return dispatch(validateCreditCodeSuccess(data));
    } catch (errorResponse) {
      dispatch(resetCreditCodesStatus());
      return dispatch(
        helpers.errorAction(VALIDATE_DISCOUNT_CODE_FAILURE, errorResponse),
      );
    }
  };
